import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import CheckboxInput from './FormInputs/CheckboxInput';

FormCheckboxField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
};

export default function FormCheckboxField({ fieldName, fieldAttributes }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={() => <CheckboxInput fieldAttributes={fieldAttributes} fieldName={fieldName} />}
    />
  );
}
